<template>
    <div class="muven-container">
        <div class="muven-router-name-container">
            <p class="muven-router-name">Usuários</p>
        </div>

        <div class="muven-content">
            <Breadcrumb :items="breadcrumbList" class="mb-3"/>

            <Loading page v-show="loading" />            

            <ConfirmationExclusionModalCmp 
                ref="confirmationExclusionModal"
                @confirm="confirmExclusionHandler" />

            <div class="mb-3" v-show="!loading">
                <div>
                    <button type="button" 
                        class="btn btn-outline-secondary mr-3"
                        :disabled="openingInvitationMemberModal"
                        v-show="userAuthenticated.isAdmin()"
                        @click="showInvitationMemberModal()">
                        Convidar membro

                        <Loading v-show="openingInvitationMemberModal" />
                    </button>

                    <button type="button" 
                        class="btn btn-outline-secondary mr-3"
                        @click="showInvitationTempAccessModal()">
                        Liberar acesso temporário
                    </button>
                </div>
            </div>

            <NothingFound 
                v-if="!loading && !hasSubscriberMemberList"
                :message="'Você não é um administrador do assinante, portanto só serão listados os usuários com acesso temporário que tenham sido liberados por você.'" />
            
            <div class="modal" tabindex="-1" role="dialog" id="muven-invitation-member-modal">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Convite de membro</h5>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-12 col-md-6 form-group">
                                    <label>Primeiro nome</label>
                                    <input type="text" 
                                        class="form-control" 
                                        v-model="userInvitationMember.firstName" />
                                </div>

                                <div class="col-12 col-md-6 form-group">
                                    <label>Sobrenome</label>
                                    <input type="text" 
                                        class="form-control" 
                                        v-model="userInvitationMember.lastName" />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12 form-group">
                                    <label>Celular</label>
                                    <input type="text" 
                                        class="form-control" 
							            v-mask="phoneMask"
                                        v-model="userInvitationMember.phone" />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12 form-group">
                                    <label>Email</label>
                                    <input type="email" 
                                        class="form-control" 
                                        v-model="userInvitationMember.email" />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12">
                                    <div class="muven-tip tip-info mb-3">
                                        <fa icon="info" class="tip-icon" />
                                        <p v-for="(role, index) in userRoleList" :key="index">
                                            <span class="text-muted"><b>{{role.name}}</b>: {{role.description}}</span>
                                        </p>
                                    </div>
                                </div>
                            </div>    

                            <div class="row">
                                <div class="col-12 form-group">
                                    <label>Função</label>
                                    <multiselect
                                        v-model="userInvitationMember.roles"
                                        :options="userRoleList"
                                        :multiple="true"
                                        :show-labels="false"
                                        label="name"
                                        track-by="enum"
                                        placeholder="" />
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" 
                                class="btn btn-primary" 
                                @click="sendInvitationToMember(userInvitationMember)"
                                :disabled="!userInvitationMember.isValid() || submittingInvitationMember">
                                    Enviar convite

                                    <Loading v-show="submittingInvitationMember" />
                            </button>

                            <button type="button" 
                                class="btn btn-outline-secondary" 
                                @click="closeInvitationMemberModal()">Fechar</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal" tabindex="-1" role="dialog" id="muven-invitation-temp-modal">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Liberar acesso temporário</h5>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-12">
                                    <div class="muven-tip tip-info mb-3">
                                        <fa icon="info" class="tip-icon" />
                                        <p><b>ATENÇÃO!</b></p>
                                        <p class="mb-3">Ao liberar o acesso temporário, a pessoa em questão terá acesso completo ao seu painel administrativo do Muven. Portanto, apenas continue caso saiba o que está fazendo.</p>
                                        <p>Para que a liberação seja efetivada, a pessoa responsável pelo acesso deve acessar o link enviado para o celular ou email preenchido abaixo.</p>
                                    </div>
                                </div>
                            </div>    

                            <div class="row">
                                <div class="col-12 form-group">
                                    <label>Liberar acesso por</label>
                                    <multiselect
                                        v-model="userInvitationTemp.hoursToInvalidate"
                                        :options="hoursToInvalidateList"
                                        :multiple="false"
                                        :show-labels="false"
                                        :allow-empty="false"
                                        label="description"
                                        track-by="enum"
                                        placeholder="" />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12 col-md-6 form-group">
                                    <label>Primeiro nome</label>
                                    <input type="text" 
                                        class="form-control" 
                                        v-model="userInvitationTemp.firstName" />
                                </div>

                                <div class="col-12 col-md-6 form-group">
                                    <label>Sobrenome</label>
                                    <input type="text" 
                                        class="form-control" 
                                        v-model="userInvitationTemp.lastName" />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12 form-group">
                                    <label>Celular</label>
                                    <input type="text" 
                                        class="form-control" 
							            v-mask="phoneMask"
                                        v-model="userInvitationTemp.phone" />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12 form-group">
                                    <label>Email</label>
                                    <input type="email" 
                                        class="form-control" 
                                        v-model="userInvitationTemp.email" />
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" 
                                class="btn btn-primary" 
                                @click="sendInvitationTempAccess(userInvitationTemp)"
                                :disabled="!userInvitationTemp.isValid() || submittingInvitationTempAccess">
                                    Enviar convite

                                    <Loading v-show="submittingInvitationTempAccess" />
                            </button>

                            <button type="button" 
                                class="btn btn-outline-secondary" 
                                @click="closeInvitationTempAccessModal()">Fechar</button>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="!loading && hasSubscriberMemberList">
                <div class="table-responsive">
                    <table class="table table-sm table-striped table-hover">
                        <thead>
                            <tr>
                                <th>Usuário</th>
                                <th>Nome</th>
                                <th>Função</th>
                                <th>Acesso expira em</th>
                                <th>Status</th>
                                <th></th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="(member, index) in subscriberMemberList" :key="index">
                                <td>{{member.username}}</td>
                                <td>{{member.getFullName() | infoOrPlaceholder}}</td>
                                <td>{{member.getRolesDescription() | infoOrPlaceholder}}</td>
                                <td>{{member.expireAt | dateTimeFilter | infoOrPlaceholder}}</td>
                                <td>
                                    <span v-show="member.isActive">
                                        <span class="muven-td-icon">
                                            <fa icon="check-circle" 
                                                class="text-success" />
                                        </span>

                                        <span>Ativo</span>
                                    </span>

                                    <span v-show="!member.isActive">
                                        <span class="muven-td-icon">
                                            <fa icon="ban" 
                                                class="text-muted" />
                                        </span>

                                        <span>Inativo</span>
                                    </span>
                                </td>
                                <td class="text-center muven-td-with-buttons">
                                    <button type="button" 
                                        class="btn btn-default text-muted" 
                                        data-toggle="dropdown" >
                                        <fa icon="ellipsis-v" v-show="!member.loadingListAction" />
                                        <fa icon="sync-alt" spin v-show="member.loadingListAction" />
                                    </button>

                                    <div class="dropdown-menu dropdown-menu-right muven-action-menu">
                                        <span class="dropdown-item muven-action-danger"
                                            @click="openConfirmationExclusionModal(member)">
                                            <fa icon="trash-alt" fixed-width class="muven-action-icon" />
                                            <span class="muven-action-label">Remover</span>
                                        </span>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ModalService from '../../utils/services/ModalService'
import userService from '@/user/services/UserService'
import { UserInvitationMemberModel } from '@/user/models/UserInvitationMemberModel'
import { UserInvitationTempModel } from '@/user/models/UserInvitationTempModel'
import subscriberService from '@/subscriber/services/SubscriberService'
import ConfirmationExclusionModalCmp from '../../utils/components/ConfirmationExclusionModalCmp'
import { infoOrPlaceholder } from '../../utils/filters/InformationOrPlaceholderFilter'
import { mapState } from 'vuex'
import {dateTimeFilter} from '@/utils/filters/DateTimeFilter'

const ID_INVITATION_MEMBER_MODAL = '#muven-invitation-member-modal'
const ID_INVITATION_TEMP_ACCESS_MODAL = '#muven-invitation-temp-modal'

export default {
    name: 'SubscriberMemberListView',
    components: {
        ConfirmationExclusionModalCmp,
    },
    filters: {
        infoOrPlaceholder,
        dateTimeFilter,
    },
    data() {
        return {
            loading: false,
            phoneMask: '(##) #####-####',
            openingInvitationMemberModal: false,
            submittingInvitationMember: false,
            submittingInvitationTempAccess: false,
            userInvitationMember: new UserInvitationMemberModel(),
            userInvitationTemp: new UserInvitationTempModel(),
            subscriberMemberList: [],
            userRoleList: [],
            hoursToInvalidateList: [
                {
                    enum: 1,
                    description: '1 hora',
                },
                {
                    enum: 2,
                    description: '2 horas',
                },
                {
                    enum: 3,
                    description: '3 horas',
                },
                {
                    enum: 4,
                    description: '4 horas',
                },
                {
                    enum: 5,
                    description: '5 horas',
                },
                {
                    enum: 6,
                    description: '6 horas',
                },
                {
                    enum: 7,
                    description: '7 horas',
                },
                {
                    enum: 8,
                    description: '8 horas',
                },
            ],
            breadcrumbList: [
                {
                    id: 0,
                    description: 'Configurações',
                    path: '/configuracoes',
                },
                {
                    id: 1,
                    description: `Usuários`,
                    path: '',
                },
            ],
        }
    },
    async mounted() {
        this.loading = true

        try {
            if (!!this.$route.query.showTempAccessForm) {
                const userInvitationTemp = new UserInvitationTempModel({
                    ...this.$route.query,
                })

                if (!!userInvitationTemp.phone) {
                    switch (userInvitationTemp.phone.length) {
                        case 10:
                            this.phoneMask = '(##) ####-####';
                            break;

                        case 11:
                            this.phoneMask = '(##) #####-####';
                            break;

                        case 13:
                            this.phoneMask = '+## (##) #####-####';
                            break;
                    }
                }

                this.showInvitationTempAccessModal(userInvitationTemp)
            }

            this.subscriberMemberList = await subscriberService.getMemberList()    
        } catch (err) {
            this.$floatingAlert.error({
                message: err.message,
            })
        }

        this.loading = false
    },
    methods: {
        async showInvitationMemberModal() {
            this.openingInvitationMemberModal = true

            if (!this.userRoleList.length) {
                this.userRoleList = await userService.getUserRoles()
            }
            
            this.userInvitationMember = new UserInvitationMemberModel()
            ModalService.show(ID_INVITATION_MEMBER_MODAL)

            this.openingInvitationMemberModal = false
        },        
        async closeInvitationMemberModal() {
            ModalService.hide(ID_INVITATION_MEMBER_MODAL)
        },
        async showInvitationTempAccessModal(userInviation = {}) {
            this.userInvitationTemp = new UserInvitationTempModel({
                ...userInviation,
                hoursToInvalidate: this.hoursToInvalidateList[2],
            })
            ModalService.show(ID_INVITATION_TEMP_ACCESS_MODAL)
        },        
        async closeInvitationTempAccessModal() {
            ModalService.hide(ID_INVITATION_TEMP_ACCESS_MODAL)
        },
        async sendInvitationToMember(userInvitation) {
            this.submittingInvitationMember = true

            try {
                const invitationNormalized = userInvitation.normalize()
                await subscriberService.sendInvitation(invitationNormalized)

                this.closeInvitationMemberModal()
                this.$floatingAlert.success({
                    message: `Convite enviado com sucesso para <b>${userInvitation.firstName}</b> no email <b>${userInvitation.email}</b>.`,
                })               
            } catch (err) {
                this.$floatingAlert.error({
                    message: err.message,
                })
            }

            this.submittingInvitationMember = false
        },
        async sendInvitationTempAccess(userInvitation) {
            this.submittingInvitationTempAccess = true

            try {
                const invitationNormalized = userInvitation.normalize()
                await subscriberService.sendInvitation(invitationNormalized)

                this.closeInvitationTempAccessModal()
                this.$floatingAlert.success({
                    message: `Convite enviado com sucesso para <b>${userInvitation.firstName}</b> no email <b>${userInvitation.email}</b>.`,
                })               
            } catch (err) {
                this.$floatingAlert.error({
                    message: err.message,
                })
            }

            this.submittingInvitationTempAccess = false
        },
        openConfirmationExclusionModal(member) {
            const info = {
                id: member.id,
                title: 'Exclusão de usuário',
                message: `Tem certeza que deseja excluir o usuário <span style="font-weight: 600; color: var(--text-soft); text-transform: uppercase; letter-spacing: 1px;">${member.username}</span>?`,
            }

            this.$refs.confirmationExclusionModal.open(info)
        },
        async confirmExclusionHandler({id}) {
            try {
                await subscriberService.deleteMember(id)

                for (let i = 0; i < this.subscriberMemberList.length; i++) {
                    if (this.subscriberMemberList[i].id === id) {
                        this.$floatingAlert.success({
                            message: `Usuário <span style="font-weight: 600; color: var(--text-soft); text-transform: uppercase; letter-spacing: 1px;">${this.subscriberMemberList[i].username}</span> excluído com sucesso.`,
                        })
                        this.subscriberMemberList.splice(i, 1)
                        break
                    }
                }
            } catch (e) {
                this.$floatingAlert.error({
                    message: e.message,
                })
            }

            this.$refs.confirmationExclusionModal.close()
        },
    },
    computed: {
        ...mapState({
            userAuthenticated: state => state.userAuthenticated,
        }),
        hasSubscriberMemberList() {
            return this.subscriberMemberList.length > 0
        },
    },
}
</script>
